import React from 'react';
import { NextPage } from 'next';
import Layout from '../../components/layout';
import { getAllDocuments } from '../../lib/markdown/template-markdown';
import {
  NEW_USERS_DIRECTORY,
  NewUsersDocument,
} from '../../lib/markdown/types/new-users';
import {
  HOW_TO_DIRECTORY,
  HowToDocument,
} from '../../lib/markdown/types/how-to';
import MarkdownListDocuments, {
  MarkdownListDocument,
} from '../../components/@markdown/MarkdownListDocuments';
import GenericContainer from '../../components/@container/generic-container';

interface Props {
  nuDocuments: NewUsersDocument[];
  htDocuments: HowToDocument[];
}

const NewUsersIndex: NextPage<Props> = ({ nuDocuments, htDocuments }) => {
  const finalNuDocuments: MarkdownListDocument[] = [];
  const finalHtDocuments: MarkdownListDocument[] = [];

  nuDocuments.forEach((nu) =>
    finalNuDocuments.push({ name: nu.slug, url: `/new-users/${nu.slug}` })
  );
  htDocuments.forEach((ht) =>
    finalHtDocuments.push({
      name: ht.slug,
      url: `/new-users/how-to/${ht.slug}`,
    })
  );

  return (
    <Layout>
      <GenericContainer
        title="New Users"
        breadcrumb={{ url: '/', text: 'Back to home' }}
      >
        <div className="content">
          <p>
            Volvotechinfo.com is Volvo’s online bookstore – one-stop-shopping
            for technical, owner, and service, information for current and
            legacy models. The Volvo Bookstore offers Printed and Electronic
            Service Bulletins, Printed Owner’s Manuals, Older Printed Service
            Manuals, and access to VIDA – Volvo’s interactive information and
            diagnostic tool for fault tracing and repairing Volvo Cars. In the
            store, browse anonymously, or establish a shopper profile to
            customize your experience and simplify repeat shopping. During
            online shopping, you can contact our helpful staff to answer
            questions about bookstore products and services. Support staff is
            available M-F, 9:00 a.m. to 5:30 p.m. EST.
          </p>
          <p>
            Please review the information in this section to learn more about
            navigating this site.
          </p>
          <p>
            NOTE for when placing orders with a credit card: If your credit card
            provider does not support AVS (Address Verification System) your
            purchase transaction request will be declined. When entering the
            billing information into the shopping cart, the address must match
            the credit card information EXACTLY or the credit card will be
            declined.
          </p>
          <MarkdownListDocuments title="How To:" documents={finalHtDocuments} />
        </div>
      </GenericContainer>
    </Layout>
  );
};

export const getStaticProps = async () => {
  const nuDocuments = getAllDocuments(NEW_USERS_DIRECTORY, ['slug']);

  const htDocuments = getAllDocuments(HOW_TO_DIRECTORY, ['slug']);

  return {
    props: {
      nuDocuments,
      htDocuments,
    },
  };
};

export default NewUsersIndex;
